import React from 'react';
import styles from './PageSubheader.module.css';

interface PageSubheaderProps {
  description: string;
  buttonLabel?: string;
  onAction?: () => void;
}

export const PageSubheader: React.FC<PageSubheaderProps> = ({
  description,
  buttonLabel = '+ New Ticket',
  onAction,
}) => {
  return (
    <div className={styles.row}>
      <p className={styles.description}>{description}</p>
      <button className={styles.button} onClick={onAction}>
        {buttonLabel}
      </button>
    </div>
  );
};
